export enum WidgetPropertyType {
  Text = 1,
  Number = 2,
  Boolean = 3,
  Colour = 4,
  Font = 5,
  List = 6,
  Theme = 7,
  LargeText = 8
}
